import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const RiskGaugeHigh = () => (
  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(-9.5229 -9.5229)">
      <g opacity="0.3" filter="url(#risk-gauge-high-filter-green)">
        <path
          d="M16.6788 34.0137C16.4551 34.4011 15.9582 34.5359 15.5849 34.2893C14.2157 33.3852 13.0208 32.2377 12.0607 30.9016C10.9428 29.3459 10.1688 27.5701 9.79015 25.6922C9.4115 23.8143 9.43685 21.8773 9.86453 20.0099C10.2318 18.4062 10.8887 16.8853 11.8006 15.5212C12.0492 15.1493 12.5595 15.081 12.9158 15.3514C13.2722 15.6219 13.3392 16.1286 13.0937 16.5026C12.3191 17.682 11.7596 18.9919 11.4436 20.3716C11.0673 22.0149 11.045 23.7194 11.3782 25.372C11.7114 27.0245 12.3925 28.5873 13.3763 29.9563C14.2022 31.1057 15.2256 32.0965 16.3967 32.8836C16.7679 33.1331 16.9025 33.6263 16.6788 34.0137Z"
          fill="#09DE85"
        />
      </g>
      <g opacity="0.3" filter="url(#risk-gauge-high-filter-yellow)">
        <path
          d="M13.4902 14.6485C13.1541 14.3532 13.1193 13.8395 13.4342 13.5217C14.5891 12.3562 15.9485 11.4093 17.4468 10.7296C19.1914 9.93822 21.0844 9.52719 23.0001 9.52383C24.9158 9.52047 26.8103 9.92487 28.5577 10.7101C30.0584 11.3846 31.4211 12.3267 32.58 13.4882C32.896 13.8048 32.863 14.3187 32.528 14.6151C32.193 14.9115 31.6829 14.878 31.3644 14.5639C30.3595 13.5733 29.1846 12.768 27.8936 12.1878C26.3559 11.4967 24.6888 11.1409 23.003 11.1438C21.3172 11.1468 19.6513 11.5085 18.116 12.2049C16.8271 12.7896 15.655 13.599 14.6537 14.5932C14.3362 14.9084 13.8263 14.9437 13.4902 14.6485Z"
          fill="#FFCA1B"
        />
      </g>
      <g opacity="0.4" filter="url(#risk-gauge-high-filter-red)">
        <path
          d="M32.4081 15.5207C33.0486 15.0086 33.9909 15.1089 34.4297 15.8019C35.1858 16.996 35.7513 18.3041 36.103 19.6793C36.5776 21.5353 36.6517 23.4711 36.3205 25.3579C35.9893 27.2448 35.2603 29.0395 34.1819 30.6229C33.3829 31.7962 32.4056 32.8334 31.2881 33.6987C30.6395 34.2007 29.7194 33.9742 29.2916 33.2744C28.8637 32.5747 29.0925 31.6682 29.7251 31.1462C30.4909 30.5144 31.1655 29.7758 31.7271 28.9511C32.5683 27.7161 33.1369 26.3162 33.3952 24.8444C33.6536 23.3727 33.5957 21.8628 33.2256 20.4151C32.9784 19.4484 32.5957 18.5243 32.0908 17.6694C31.6738 16.9632 31.7675 16.0329 32.4081 15.5207Z"
          fill="#E44258"
        />
      </g>
      <path
        d="M17.1176 33.2537C16.6516 34.0609 15.6116 34.3454 14.8688 33.7824C13.7967 32.9697 12.8494 31.9993 12.0607 30.9016C10.9428 29.3459 10.1688 27.5701 9.79015 25.6922C9.4115 23.8143 9.43685 21.8773 9.86453 20.0099C10.1663 18.6924 10.6635 17.4307 11.3369 16.2661C11.8035 15.4593 12.8724 15.3185 13.6148 15.882C14.3572 16.4455 14.4877 17.4995 14.0551 18.325C13.6524 19.0937 13.3491 19.913 13.1544 20.7634C12.8336 22.1639 12.8146 23.6167 13.0986 25.0251C13.3826 26.4335 13.963 27.7654 14.8015 28.9322C15.3106 29.6406 15.9077 30.2784 16.5768 30.831C17.2954 31.4244 17.5835 32.4466 17.1176 33.2537Z"
        fill="#E0E1E5"
      />
      <path
        d="M32.2499 15.6472C32.9778 15.0652 34.05 15.179 34.5367 15.9738C35.2393 17.1211 35.7681 18.3698 36.103 19.6793C36.5776 21.5353 36.6517 23.4711 36.3205 25.3579C35.9893 27.2448 35.2603 29.0395 34.1819 30.6229C33.4211 31.7401 32.4986 32.734 31.4472 33.5735C30.7189 34.155 29.6721 33.8968 29.1859 33.1017C28.6997 32.3066 28.962 31.2774 29.6655 30.666C30.3205 30.0968 30.9013 29.4442 31.3924 28.7231C32.2012 27.5356 32.7479 26.1895 32.9963 24.7744C33.2447 23.3592 33.1891 21.9074 32.8332 20.5155C32.617 19.6702 32.2932 18.8588 31.8712 18.1005C31.4181 17.2862 31.522 16.2292 32.2499 15.6472Z"
        fill="#E44258"
      />
      <path
        d="M14.1494 15.2276C13.4493 14.6125 13.3741 13.5369 14.0717 12.9189C15.0787 12.0268 16.2158 11.288 17.4468 10.7296C19.1914 9.93822 21.0844 9.52719 23.0001 9.52383C24.9158 9.52047 26.8103 9.92487 28.5577 10.7101C29.7906 11.2642 30.9303 11.999 31.9405 12.8876C32.6402 13.5031 32.5688 14.579 31.8708 15.1965C31.1728 15.8141 30.1136 15.7356 29.3888 15.1497C28.714 14.6042 27.97 14.1462 27.1742 13.7886C25.8637 13.1996 24.4428 12.8963 23.0061 12.8988C21.5693 12.9013 20.1495 13.2096 18.8411 13.8032C18.0466 14.1636 17.3041 14.6242 16.6312 15.172C15.9085 15.7605 14.8496 15.8427 14.1494 15.2276Z"
        fill="#E0E1E5"
      />
    </g>
    <g transform="translate(11.58 11.58) rotate(-30 1.92 1.92)">
      <path
        d="M1.92285 0C2.80232 0.0000902861 3.54182 0.59125 3.77051 1.39746L11.3584 6.1416L2.85742 3.60156C2.5806 3.75602 2.26235 3.84567 1.92285 3.8457C0.861069 3.8457 0.000109 2.98461 0 1.92285C0 0.861002 0.861002 0 1.92285 0Z"
        fill="#313036"
      />
    </g>
    <defs>
      <filter
        id="risk-gauge-high-filter-green"
        x="0"
        y="5.66339"
        width="26.3114"
        height="38.274"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="4.7619" result="effect1_foregroundBlur_0_4" />
      </filter>
      <filter
        id="risk-gauge-high-filter-yellow"
        x="3.6931"
        y="0"
        width="38.6299"
        height="24.3748"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="4.7619" result="effect1_foregroundBlur_0_4" />
      </filter>
      <filter
        id="risk-gauge-high-filter-red"
        x="24.5528"
        y="10.6781"
        width="16.491"
        height="27.8116"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="2.26" result="effect1_foregroundBlur_0_4" />
      </filter>
    </defs>
  </svg>
)

export default withDefaultStyles(RiskGaugeHigh)
